import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
var VeltCommentDialogThreadCardAttachmentsOtherDownload = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-download-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentDialogThreadCardAttachmentsOtherDownload;
